import React from 'react';
import { Package, Clock, Users, Headphones } from 'lucide-react';
import { companyStats } from '../mockData';

const iconMap = {
  Package: Package,
  Clock: Clock,
  Users: Users,
  Headphones: Headphones
};

export const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          {/* Image Side */}
          <div className="relative">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1665521032636-e8d2f6927053"
                alt="Shaw Transport delivery fleet"
                className="w-full h-[500px] object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute top-8 -left-8 w-full h-full bg-orange-500 rounded-2xl -z-10"></div>
          </div>

          {/* Content Side */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About <span className="text-orange-500">Shaw Transport & Logistics</span>
            </h2>
            <div className="space-y-4 text-gray-600 text-lg leading-relaxed">
              <p>
                Founded with a mission to revolutionize courier services, Shaw Transport & Logistics has grown into a trusted name in the delivery industry. We specialize in providing reliable, efficient, and professional transportation solutions for businesses and individuals alike.
              </p>
              <p>
                Our fleet of modern Mercedes Sprinter and Ford Transit vans ensures we can handle deliveries of all sizes, from small parcels to large freight. With a focus on Less Than Truckload (LTL) shipping and Last Mile Delivery, we bridge the gap between suppliers and customers seamlessly.
              </p>
              <p>
                What sets us apart is our specialization in critical sectors: medical supplies requiring temperature control and time-sensitive delivery, automobile parts needing secure handling, and standard parcels delivered with the same level of care and professionalism.
              </p>
              <p className="font-semibold text-gray-900">
                At Shaw Transport, we don't just deliver packages—we deliver peace of mind.
              </p>
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="bg-gray-800 rounded-2xl p-8 md:p-12">
          <h3 className="text-3xl font-bold text-white text-center mb-12">
            Our Track Record Speaks for Itself
          </h3>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {companyStats.map((stat) => {
              const IconComponent = iconMap[stat.icon];
              return (
                <div key={stat.id} className="text-center">
                  <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center">
                      <IconComponent className="text-white" size={32} />
                    </div>
                  </div>
                  <div className="text-4xl md:text-5xl font-bold text-orange-500 mb-2">
                    {stat.value}
                  </div>
                  <div className="text-gray-300 text-sm md:text-base font-medium">
                    {stat.label}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
